/**
 * Loads the same realizations section as on /pages/realizacje into the PDP modal (Section Rendering API).
 */
(function () {
  var modalId = 'PopupModal-Realizations';

  function loadGallery(modal, root) {
    if (!modal || !root) return;
    if (root.dataset.loaded === 'true' || root.dataset.loaded === 'loading') return;

    var fetchPath = (root.dataset.fetchPath || '/pages/realizacje').trim();
    var sectionKey = (root.dataset.sectionKey || '').trim();

    root.dataset.loaded = 'loading';

    function injectHtml(html) {
      var wrap = document.createElement('div');
      wrap.className = 'tp-realizations-modal-injected shopify-section';
      wrap.innerHTML = html;
      root.innerHTML = '';
      root.appendChild(wrap);
      root.dataset.loaded = 'true';
      applyModalMobileLayout();
    }

    function applyModalMobileLayout() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var modal = document.getElementById(modalId);
      if (!modal) return;
      var items = modal.querySelectorAll('.tp-realizations__item');
      items.forEach(function (item) {
        var overlay = item.querySelector('.tp-realizations__overlay');
        var meta = item.querySelector('.tp-realizations__meta');
        var btn = item.querySelector('.tp-realizations__order-btn');
        if (overlay) {
          overlay.style.position = 'relative';
          overlay.style.inset = 'auto';
          overlay.style.background = '#f7f2ea';
          overlay.style.opacity = '1';
        }
        if (meta) meta.style.transform = 'none';
        if (btn) {
          btn.style.position = 'static';
          btn.style.opacity = '1';
          btn.style.transform = 'none';
          btn.style.pointerEvents = 'auto';
          btn.style.width = '100%';
        }
        var name = item.querySelector('.tp-realizations__product-name');
        var price = item.querySelector('.tp-realizations__product-price');
        if (name) name.style.color = '#3e3d3d';
        if (price) price.style.color = '#ba7a4b';
      });
    }

    function loadFromPageHtml() {
      return fetch(fetchPath, { headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTML HTTP ' + res.status);
          return res.text();
        })
        .then(function (htmlText) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(htmlText, 'text/html');
          /* Najpierw galeria siatkowa (strona Realizacje); karuzela tylko gdy brak galerii */
          var sectionNode =
            doc.querySelector('.tp-realizations') ||
            doc.querySelector('[id^="Realizations-"]') ||
            doc.querySelector('.tp-realizations-carousel-sec') ||
            doc.querySelector('[id^="RealizationsCarousel-"]');
          if (!sectionNode) throw new Error('Missing realizations section in HTML');
          var shopifySection = sectionNode.closest('.shopify-section');
          injectHtml(shopifySection ? shopifySection.outerHTML : sectionNode.outerHTML);
        });
    }

    if (!sectionKey) {
      loadFromPageHtml().catch(function (err) {
        console.error('[tapanda-realizations-modal]', err);
        root.innerHTML =
          '<p class="tp-realizations-modal-root__error" role="alert">Nie udało się załadować galerii. Sprawdź ustawienia motywu (ścieżka strony i klucz sekcji) lub odśwież stronę.</p>';
        root.dataset.loaded = 'error';
      });
      return;
    }

    var sep = fetchPath.indexOf('?') >= 0 ? '&' : '?';
    var url = fetchPath + sep + 'sections=' + encodeURIComponent(sectionKey);
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var html = data && data[sectionKey];
        if (!html || typeof html !== 'string') throw new Error('Missing section fragment');
        injectHtml(html);
      })
      .catch(function () {
        return loadFromPageHtml();
      })
      .catch(function (err) {
        console.error('[tapanda-realizations-modal]', err);
        root.innerHTML =
          '<p class="tp-realizations-modal-root__error" role="alert">Nie udało się załadować galerii. Sprawdź ustawienia motywu (ścieżka strony i klucz sekcji) lub odśwież stronę.</p>';
        root.dataset.loaded = 'error';
      });
  }

  function init() {
    var modal = document.getElementById(modalId);
    var root = document.getElementById('tp-realizations-modal-root');
    if (!modal || !root) return;

    var obs = new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        loadGallery(modal, root);
      }
    });
    obs.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
